import { createContext, useContext } from "react";

export const DEFAULT_CONTENT = {
  hero_tagline: "APERTA 24/7 — 365 GIORNI L'ANNO",
  manifesto_1:
    "Full Stack nasce da una passione autentica per il fitness e il bodybuilding e dalla necessità di creare una palestra diversa dalle solite: un luogo pensato da chi si allena davvero.",
  manifesto_2:
    "Ogni dettaglio, dalla scelta dei macchinari con i migliori marchi al mondo, all’organizzazione degli spazi, è stato studiato per offrire un’esperienza di allenamento completa, professionale e senza compromessi. Full Stack unisce l’anima delle palestre americane old school a un ambiente moderno, curato e accogliente, adatto sia agli atleti più esperti sia a chi vuole iniziare il proprio percorso.",
  manifesto_3:
    "Aperta 24 ore su 24, 365 giorni all’anno, Full Stack permetterà a tutti di allenarsi liberamente, secondo i propri ritmi e senza limiti di orario.",
  manifesto_4:
    "Non sarà soltanto una palestra, ma un luogo in cui costruire forza, disciplina e risultati, creando una vera community e amicizie solide unite dalla stessa passione.",
  sala_pesi_subtitle:
    "Il cuore della Full Stack: macchinari dei migliori marchi al mondo, spazi studiati per allenarti senza compromessi.",
  sala_posing_subtitle:
    "Uno spazio dedicato per controllare i propri miglioramenti fisici, con le luci adatte per valorizzare ogni minimo dettaglio.",
  zona_relax_subtitle:
    "Il recupero è parte dell'allenamento: un ambiente curato e accogliente per ricaricare le energie.",
  brand_subtitle: "I prodotti che potrai acquistare in sede per poterti allenare al meglio!",
  abbonamenti_desc:
    "Da qui puoi iscriverti alla Full Stack e acquistare direttamente il tuo abbonamento o il tuo ingresso: scegli la formula che fa per te, completa l'acquisto online in pochi click e vieni ad allenarti. Accesso illimitato 24 ore su 24, 365 giorni all'anno.",
  coaching_desc:
    "Vuoi un percorso su misura? Da qui puoi prenotare direttamente le tue lezioni personal one to one con i nostri coach: scegli giorno e orario, e lavora con un professionista su tecnica, programmazione e risultati.",
  giftcard_desc:
    "Fai il regalo più utile: una Gift Card Full Stack. Da qui puoi acquistarla in pochi click e regalarla a chi vuoi — è utilizzabile su qualsiasi abbonamento e su tutti gli articoli in sede.",
  logbook_desc:
    "Il Logbook è il tuo diario di allenamento digitale: serve a tracciare ogni miglioramento che fai in sala pesi, così ogni progresso resta scritto nero su bianco.",
  logbook_url: "https://fullstack-gym.com/login",
  instagram_url: "https://instagram.com/fullstackgym_",
  map_lat: "38.418500",
  map_lng: "15.902972",
  contact_phone: "346 544 9988",
  contact_email: "fullstackgym26@gmail.com",
  contact_address: "SP1 155, Gioia Tauro 89013 (RC)",
};

export const ContentContext = createContext({});

export function useContent() {
  return { ...DEFAULT_CONTENT, ...useContext(ContentContext) };
}
